import { useRef, useCallback, useEffect } from "react";

import { logger } from "../../../shared/logger";

export function useInactivityTimeout(
	callback: () => void,
	defaultMs: number = 15000,
) {
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	const clear = useCallback(() => {
		if (timeoutRef.current !== null) {
			logger.debug("inactivity timeout: clearing");
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		}
	}, []);

	const start = useCallback(
		(durationMs: number = defaultMs) => {
			clear();

			logger.debug("inactivity timeout: starting", { durationMs });
			timeoutRef.current = setTimeout(() => {
				timeoutRef.current = null;
				logger.debug("inactivity timeout: callback");
				callback();
			}, durationMs);
		},
		[callback, clear, defaultMs],
	);

	useEffect(() => clear, [clear]);

	return { clear, start };
}
